import React from 'react'
import {
    Box,
    CircularProgress,
    Grid,
    Typography,
    makeStyles,
    Theme,
} from '@material-ui/core'

import { UseLeasingSeasonReturn } from '../hooks/useLeasingSeason'
import { buildDemoAiRecommendation } from '../utils/demoProgress'
import { AutomationsCard } from './AutomationsCard'
import { MonthlyTokensCard } from './MonthlyTokensCard'
import { TokenAllocationPanel } from './TokenAllocationPanel'

const useStyles = makeStyles((theme: Theme) => ({
    topRow: {
        marginBottom: 0,
    },
}))

interface TokensAndAutomationsHomeProps {
    leasingSeason: UseLeasingSeasonReturn
}

export const TokensAndAutomationsHome: React.FC<TokensAndAutomationsHomeProps> = ({
    leasingSeason,
}) => {
    const classes = useStyles()
    const {
        season,
        hasSeason,
        isListLoading,
        isDetailLoading,
        selectedSeasonId,
        isViewingCurrentSeason,
        aiRecommendation,
        monthlyTokens,
        tokenBalance,
        tokensSpentThisMonth,
        updateAllocation,
        resetAllocations,
    } = leasingSeason

    if (isListLoading || isDetailLoading) {
        return (
            <Box display="flex" justifyContent="center" py={6}>
                <CircularProgress />
            </Box>
        )
    }

    if (!hasSeason || !season) {
        return (
            <Box py={4} textAlign="center">
                <Typography color="textSecondary" variant="body2">
                    No season selected.
                </Typography>
            </Box>
        )
    }

    const displayRecommendation =
        aiRecommendation ?? buildDemoAiRecommendation()

    return (
        <Box>
            <Grid container spacing={2} className={classes.topRow}>
                <Grid item xs={12} lg={5}>
                    <MonthlyTokensCard
                        monthlyBudget={monthlyTokens}
                        currentBalance={tokenBalance}
                        tokensSpentThisMonth={tokensSpentThisMonth}
                    />
                </Grid>
                <Grid item xs={12} lg={7}>
                    <TokenAllocationPanel
                        config={season}
                        recommendation={displayRecommendation}
                        monthlyTokens={monthlyTokens}
                        onAllocationChange={updateAllocation}
                        onReset={resetAllocations}
                    />
                </Grid>
            </Grid>

            <AutomationsCard
                seasonId={selectedSeasonId}
                readOnly={!isViewingCurrentSeason}
                tokenBalance={tokenBalance}
                enrichingPercent={season.allocations.prospecting}
            />
        </Box>
    )
}
